import prepareOptions from '../../prepareOptions';
import { EURO1, EURO2, EURO3, EURO4, EURO5, EURO6 } from './values';

export default prepareOptions([
  {
    value: EURO1,
    label: __('carDetails.equipmentGroups.euro1'),
  },
  {
    value: EURO2,
    label: __('carDetails.equipmentGroups.euro2'),
  },
  {
    value: EURO3,
    label: __('carDetails.equipmentGroups.euro3'),
  },
  {
    value: EURO4,
    label: __('carDetails.equipmentGroups.euro4'),
  },
  {
    value: EURO5,
    label: __('carDetails.equipmentGroups.euro5'),
  },
  {
    value: EURO6,
    label: __('carDetails.equipmentGroups.euro6'),
  },
]);
